import { useMemo } from 'react';
import { useUserLoggedIn } from '~/modules/user';
import type { Conversation } from '../../types';
import { getChatParticipants } from '../../utils';
import { GroupChatAvatar } from '../avatar/GroupChatAvatar';
import { ThumbnailAvatar } from '../avatar/ThumbnailAvatar';

/**
 * The avatar component for a chat inbox list item. This is determined by the conversation
 * type, participants, and thumbnail settings.
 * @see {@link ChatInboxListItem}
 */
export function ChatInboxListItemAvatar({
    conversation,
}: {
    conversation: Conversation;
}) {
    const { user, isLoggedIn } = useUserLoggedIn();
    const isDirectConversation =
        conversation.__typename === 'DirectConversation';
    const isGroupChat = isDirectConversation && conversation.IsGroupChat;
    const participants = useMemo(() => {
        return isGroupChat
            ? getChatParticipants(conversation)
            : getChatParticipants(conversation, isLoggedIn ? user.ID : 0);
    }, [isGroupChat, conversation, isLoggedIn, user.ID]);

    return isDirectConversation && conversation.Thumbnail?.Link ? (
        <ThumbnailAvatar
            className="size-12"
            src={conversation.Thumbnail.Link}
        />
    ) : (
        <GroupChatAvatar
            className="size-12"
            avatarClassName="size-12"
            fallbackClassName="!text-6"
            participants={participants}
            maxAvatars={isGroupChat ? 7 : 1}
        />
    );
}
